import sendApiRequest from '../helpers/axios-setup';

export async function fetchParentQueries(params) {
  try {
    const response = await sendApiRequest.get(`/parent-query`, { params });
    return response.data.data[0];
  } catch (error) {
    throw error;
  }
}

export async function answerParentQuery(queryId, data) {
  try {
    const response = await sendApiRequest.put(`/parent-query/${queryId}`, data);
    return response.data.data;
  } catch (error) {
    throw error;
  }
}

export async function publishParentQuery(queryId, data) {
  try {
    const response = await sendApiRequest.put(
      `/parent-query/${queryId}/publish`,
      data
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
}
